/**
 * Skeleton loader for mobile Order Summary (inside gray card)
 * Shows layout while cart data is loading on mobile/tablet
 */
export function MobileOrderSummarySkeleton() {
  return (
    <div className="lg:hidden mb-8">
      <div className="bg-gray-50 rounded-2xl p-4 space-y-4 motion-safe:animate-pulse">
        {/* Pickup details skeleton */}
        <div className="space-y-3">
          <div className="h-4 w-24 bg-gray-200 rounded" />
          <div className="h-3 w-full bg-gray-200 rounded" />
          <div className="h-3 w-3/4 bg-gray-200 rounded" />
        </div>

        <div className="border-t border-gray-200" />

        {/* Order items skeleton */}
        <div className="space-y-3">
          <div className="h-5 w-32 bg-gray-200 rounded" />
          {[1, 2].map((i) => (
            <div key={i} className="flex justify-between">
              <div className="h-4 w-32 bg-gray-200 rounded" />
              <div className="h-4 w-16 bg-gray-200 rounded" />
            </div>
          ))}
        </div>

        <div className="border-t border-gray-200" />

        {/* Totals skeleton */}
        <div className="space-y-2">
          {[1, 2, 3].map((i) => (
            <div key={i} className="flex justify-between">
              <div className="h-4 w-20 bg-gray-200 rounded" />
              <div className="h-4 w-12 bg-gray-200 rounded" />
            </div>
          ))}
        </div>

        {/* Total skeleton */}
        <div className="border-t border-gray-200 pt-3">
          <div className="flex justify-between">
            <div className="h-5 w-16 bg-gray-200 rounded" />
            <div className="h-5 w-20 bg-gray-200 rounded" />
          </div>
        </div>

        {/* Tip skeleton */}
        <div className="border-t border-gray-200 pt-3 space-y-2">
          <div className="h-4 w-24 bg-gray-200 rounded" />
          <div className="flex gap-2">
            {[1, 2, 3, 4].map((i) => (
              <div key={i} className="flex-1 h-12 bg-gray-200 rounded" />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

